export const formatDisplayName = (first, last) => {
    return first + (last.length > 0 ? ` ${last.substring(0, 1)}.` : "");
};
